import React from 'react';
import cn from 'classnames';

import LoadingDots from 'widget/shared/ui/LoadingDots';

import styles from './TypingMessage.module.scss';

type TypingMessageProps = {
  className?: string;
};

const TypingMessage: React.FC<TypingMessageProps> = ({ className }) => {
  return (
    <div className={cn(styles['typing-message'], className)}>
      <LoadingDots className={styles['typing-message__dots']} />
    </div>
  );
};

export default React.memo(TypingMessage);
